import Layout from '@/layouts/BasicLayout/index.vue'
import { ROLE_TYPE } from '@/utils/roleControl'
import type { RouteRecordRaw } from 'vue-router'

const vairety: RouteRecordRaw = {
  path: '/setting',
  name: 'Setting',
  redirect: '/setting/menu',
  component: Layout,
  meta: {
    title: '设置中心',
    module: 'Setting',
    icon: 'setting|svg',
    menuOfRoleType: [ROLE_TYPE.ADMIN]
  },
  children: [
    // 菜单配置
    {
      path: 'menu',
      name: 'MenuConfig',
      component: () => import('@/views/Setting/MenuConfig/index.vue'),
      meta: {
        title: '菜单配置',
        module: 'MenuConfig',
        menuOfRoleType: [ROLE_TYPE.ADMIN]
      }
    },
    {
      path: 'notice-config',
      name: 'NoticeConfig',
      component: () => import('@/views/Notice/List/index.vue'),
      meta: {
        title: '公告配置',
        module: 'NoticeConfig',
        menuOfRoleType: [ROLE_TYPE.ADMIN]
      }
    }
  ]
}

export default vairety
